// 商品検索カテゴリの開閉
window.addEventListener('DOMContentLoaded', () => {
  const categories = document.getElementById("js-search-items-header-categories");
  const opener = categories.querySelector(".search-items-header-categories__opener");
  const closure = categories.querySelector(".search-items-header-categories__closure");
  opener.addEventListener("click", () => {
    categories.classList.add("search-items-header-categories--active");
  });
  closure.addEventListener("click", () => {
    categories.classList.remove("search-items-header-categories--active");
  });
});
